module.exports = __webpack_public_path__ + "media/customizations/sienna/logo-e00587c643ec9813fb7c402e07f0c99f.png";